import React from 'react';

const SaveStatusChip = ({ status, onRetry }) => {
    if (status === 'saving') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-white/5 text-neutral-400">Saving…</span>;
    if (status === 'saved') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-emerald-500/15 text-emerald-300">Saved ✓</span>;
    if (status === 'invalid') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-amber-500/15 text-amber-300">Not saved — check fields</span>;
    if (status === 'error') return (
        <span className="inline-flex items-center gap-2 px-2 py-0.5 rounded-full text-xs bg-red-500/15 text-red-300">
            Couldn't save —
            <button onClick={onRetry} className="underline hover:text-red-200">Retry</button>
        </span>
    );
    return null;
};

export default SaveStatusChip;
